import { useEffect } from 'react';
import config from '@cof/ukweb-config/lib/clientConfig';
import { useBrand } from '@cof/plastic-components';
import { setNewRelicAttribute } from '../newRelic';
import { useAdobeExperiments } from '../../experiments/AdobeExperiment/AdobeExperimentProvider';
import { getFullExperimentString } from '../../experiments/getExperimentString';

const buildQuantumPageStartAttributes = ({
    formDefinitionId,
    onlineEntryMethodCode,
    journeyType,
    consumerName,
    doubleClickId,
    experimentChar,
    webpageChar,
    brand,
    adobeExperiment,
    isEdit
}: any) => ({
    formDefinitionId,
    onlineEntryMethodCode,
    journeyType,
    consumerName,
    doubleClickId,
    experimentChar,
    webpage: webpageChar || 'x',
    brand,
    adobeExperiment,
    isEdit
});

const conditionalSetNewRelicAttribute = (attributeName: any, attributeValue: any) => {
    // set new relic attribute if that attribute is not undefined
    if (attributeValue) setNewRelicAttribute(attributeName, attributeValue);
};

export const useQuantumMetric = ({
    formDefinitionId,
    onlineEntryMethodCode,
    consumerName,
    journeyType,
    doubleClickId,
    experimentChar,
    webpageChar,
    isEdit
}: any) => {
    const brand = useBrand();
    const quantumMetricEnabled = config.get('quantumMetric.isEnabled') && window?.QuantumMetricAPI?.isOn();
    const adobeState = useAdobeExperiments();
    const trackQuantumEvent = (eventID: any, conversion: any, primaryValue: any, attributes: any) => {
        if (quantumMetricEnabled) {
            conditionalSetNewRelicAttribute('quantumMetricUserId', window?.QuantumMetricAPI?.getUserID?.());
            conditionalSetNewRelicAttribute('quantumMetricSessionId', window?.QuantumMetricAPI?.getSessionID?.());
            try {
                attributes
                    ? // @ts-expect-error TS18048: 'window.QuantumMetricAPI' is possibly 'undefined'.
                      window.QuantumMetricAPI.sendEvent(eventID, conversion, primaryValue, attributes)
                    : // @ts-expect-error TS18048: 'window.QuantumMetricAPI' is possibly 'undefined'.
                      window.QuantumMetricAPI.sendEvent(eventID, conversion, primaryValue);
            } catch (e) {
                // eslint-disable-next-line no-console
                // @ts-expect-error TS18046: 'e' is of type 'unknown'.
                console.log(e.message);
            }
        }
    };

    useEffect(() => {
        const adobeExperiment = getFullExperimentString(adobeState);

        if (onlineEntryMethodCode && journeyType && consumerName && quantumMetricEnabled) {
            const quantumPageStartAttributes = buildQuantumPageStartAttributes({
                formDefinitionId,
                onlineEntryMethodCode,
                journeyType,
                consumerName,
                doubleClickId,
                experimentChar,
                webpageChar,
                brand,
                adobeExperiment,
                isEdit
            });
            trackQuantumEvent(13, 0, true, quantumPageStartAttributes);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formDefinitionId,
        onlineEntryMethodCode,
        consumerName,
        journeyType,
        doubleClickId,
        experimentChar,
        webpageChar,
        isEdit,
        quantumMetricEnabled,
        adobeState
    ]);

    return { trackQuantumEvent };
};
